import modelFactory from '../modelFactory';
import valueFilters from '../valueFilters';
import validator from '../validator';
import util from '../util';

export interface IProposalWorkArea {
	key: string,
	name?: string;
	details?: any;
	sortIndex: number;
}

const workAreaFactory = modelFactory.createFactory<IProposalWorkArea>('ProposalWorkArea', {
	key: {
		defaultValue: util.generateGuid
	},
	name: {
	},
	details: {
	},
	sortIndex: {
		setFilters: valueFilters.cleanNumber,
		getFilters: valueFilters.toNumber,
		rules: validator.number(),
		defaultValue: 0.0
	}
});

export default workAreaFactory;